"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const EmailIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props, { viewBox: "0 0 100 100" }),
    react_1.default.createElement("g", { transform: "translate(0,-952.36218)" },
        react_1.default.createElement("path", { d: "M 13.78125,975.3622 50,1004.5184 l 36.21875,-29.1562 -72.4375,0 z M 9,979.1747 l 0,50.1875 82,0 0,-50.1875 -39.125,31.5 a 3.0003,3.0003 0 0 1 -3.75,0 L 9,979.1747 z" }))));
exports.EmailIcon = EmailIcon;
exports.default = exports.EmailIcon;
